import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateHtml' })
export class TruncateHtmlPipe implements PipeTransform {
  transform(text: string): string {
    return TruncateHtmlPipe.truncateText(text);
  }

  public static truncateText(text: string): string {
    if (!text || typeof text !== 'string') {
      return text;
    }
    return text
      .replace(/<(?:.|\n)*?>/gm, '') 
      .replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\n/g, '<br>')
      .trim();
  }
}
